import request from '@/utils/request'

export function siteSearchFilterList () {
  const method = 'get'
  const url = `/site`
  return request({
    url,
    method
  })  
}

export function nextIndex (countryCode) {
  const method = 'get'
  const url = `/next_site_index/` + countryCode
  return request({
    url,
    method
  })  
}

export async function siteProtocol (entity, search, item) {
  const method = 'get'
  const url = `/protocol_has_site`

  //issue vari miletto
  const filters =  {'protocol_id': (item?.protocol_id??0)}
  if (search)
  {
    filters['site.factor_label'] = `%${search}%`
  }
  //issue vari miletto

  const ps = await request({
    url,
    method,
    headers: {
      'x-filters' : JSON.stringify(filters),
      //issue 263
      'x-pagination' : JSON.stringify({rowsPerPage: -1, sortBy:"site.factor_label","descending":false})
      //issue 263
    }
  })
  return { data : ps.data.map( el => el.site)}
}